import { lazy, Suspense } from 'react';
import { createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { Flex } from '@chakra-ui/react';
import { Outlet } from '@tanstack/react-router';
import { TAuthContext } from '@/context/auth';
import { BACKGROUND_COLOR } from '@/constants/ui';
import NotFoundPage from '@/components/templates/NotFoundPage';
import ErrorBoundaryComponent from '@/components/templates/ErrorBoundaryComponent';
import * as Sentry from '@sentry/react';

const TanStackRouterDevtools =
  import.meta.env.MODE === 'production'
    ? () => null // Render nothing in production
    : lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: TAuthContext | null;
}>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
  // Last-resort catch, outside the sidebar shell — so it renders the full-page
  // variant. Routes inside the shell carry their own ErrorBody boundaries.
  errorComponent: ErrorBoundaryComponent,
});

function RootComponent() {
  return (
    <Sentry.ErrorBoundary fallback={ErrorBoundaryComponent}>
      <Flex backgroundColor={BACKGROUND_COLOR} justifyContent={'center'}>
        <Outlet />
      </Flex>
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    </Sentry.ErrorBoundary>
  );
}
